<template>
   <div class="ancillaries-calculator-c">
      <!-- Reverse Btn Wrapper -->

      <div class="countdown">{{ formattedTime }}</div>

      <div class="reverse-btn-wrapper" v-if="reversable.withPenalty && reversable.isReversable">
         <i class="gts-icon icon-order-reverse icon-lg"></i>
         <div class="reverse-btn-information-txt-wrapper">
            <template v-if="calculate.status">
               <span class="txt-black txt-large"> {{ $t("flightOrderDetail_lblCalculatingPenalty") }} </span>
               <span class="txt-normal txt-small">{{ $t("flightOrderDetail_lblCalculatingPenaltyTxt") }}</span>
            </template>
            <template v-else-if="calculate.isCalculated">
               <span class="txt-black txt-large"> {{ $t("flightOrderDetail_lblRefundWithPenalty") }} </span>
               <span class="txt-normal txt-small"> {{ $t("common_total_refund") }}: {{ reversable.refund }} {{ reversable.currency }} </span>
               <span class="txt-normal txt-small"> {{ $t("common_total_penalty") }}: {{ reversable.penalty }} {{ reversable.currency }} </span>
            </template>
            <template v-else>
               <span class="txt-black txt-large"> {{ $t("flightOrderDetail_lblCancellationWithPenalty") }} </span>
               <span class="txt-normal txt-small">{{ $t("flightOrderDetail_lblCancellationWithPenaltyTxt") }}</span>
            </template>
         </div>
         <div class="reverse-btn-action">
            <template v-if="calculate.status">
               <lottie-animation :speed="0.75" path="assets/animations/calculating.json" id="reverse-animation" />
            </template>
            <template v-else-if="calculate.isCalculated">
               <button @click="funcReverse">
                  {{ SetReverseButtonText }}
               </button>
            </template>
            <template v-else>
               <button @click="handlerCalculateReverse">{{ $t("flightOrderDetail_btnCalculatePenalty") }}</button>
            </template>
         </div>
      </div>

      <template v-else>
         <span>
            <UIButton :className="reversable.withPenalty ? 'purple' : 'warning'" :text="SetReverseButtonText" @click.native="funcReverse" />
         </span>
      </template>
   </div>
</template>
<script>
import UIButton from "@/components/unitary/Button.vue";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
export default {
   name: "AncillariesCalculator",
   props: {
      settings: Object,
   },
   components: {
      UIButton,
      LottieAnimation,
   },

   data() {
      return {
         timeRemaining: this.settings.secondsLeft,
         intervalId: null,
         calculate: {
            status: false,
            isCalculated: false,
         },
         reversable: {
            withPenalty: false,
            isReversable: false,
         },
      };
   },
   created() {
      if (this.settings.result.success && [1, 2, 3, 6].includes(this.settings.enabledReverseType)) {
         //1: "VOIDABLE",2: "REFUNDABLE_WO_PENALTY",3: "REFUNDABLE_WITH_PENALTY",6: "CANCELABLE"

         this.reversable = {
            withPenalty: false,
            isReversable: true,
         };
         if (this.settings.enabledReverseType == 3)
            this.reversable = {
               withPenalty: true,
               isReversable: true,
               penalty: this.settings.penalty,
               currency: this.settings.currency,
               refund: this.settings.refund,
            };
         if (this.settings.secondsLeft > 0)
            setTimeout(() => {
               this.reversable.isReversable = false;
            }, this.settings.secondsLeft * 1000);
      }
      this.startCountdown();
   },
   computed: {
      SetReverseButtonText() {
         if (this.reversable.withPenalty) {
            return this.$t("flightOrderDetail_btnReverseWithPenalty");
         } else {
            return this.$t("flightOrderDetail_btnReverse");
         }
      },
      formattedTime() {
         const minutes = Math.floor(this.timeRemaining / 60);
         const seconds = this.timeRemaining % 60;
         return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
      },
   },
   methods: {
      funcReverse() {
         console.log("funcReverse");
         this.$emit("calculate", this.reversable);
      },
      handlerCalculateReverse() {
         this.calculate.status = true;
         const random = (min, max) => Math.floor(Math.random() * (max - min)) + min;
         setTimeout(() => {
            this.calculate.status = false;
            this.calculate.isCalculated = true;
         }, random(3, 5) * 1000);
      },
      startCountdown() {
         this.intervalId = setInterval(() => {
            if (this.timeRemaining > 0) {
               this.timeRemaining -= 1;
            } else {
               clearInterval(this.intervalId);
               this.handlerClosePopup();
            }
         }, 1000);
      },
      // handlerClosePopup() {
      //    this.$store.commit("seatmap/setStatus", false);
      // },
   },
};
</script>

<style scoped lang="scss">
@keyframes countdownAnimation {
   from {
      color: #363636;
   }
   to {
      color: #e2e2e2;
   }
}
.countdown {
   margin-right: 1rem;
   margin-bottom: 1rem;
   font-weight: 500;
   font-size: 2rem;
   animation: countdownAnimation 1s ease-in-out infinite;
   font-family: "Roboto Mono";
   // background-color: #eee;
   // border: 1px solid #eee;
   border-radius: 0.5rem;
   padding: 0 0.5rem;
   margin-top: -5px;
}
.ancillaries-calculator-c {
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;

   h6 {
      margin-bottom: 0.5rem;
   }
}
</style>
